/**
 * Ephemera Archive - Frontend Entry Point
 */

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

// Create Vue app
const app = createApp(App);

// Create Pinia store
const pinia = createPinia();
app.use(pinia);

// Add router
app.use(router);

// Mount app
app.mount('#app');
